import { CostsPeriod } from './costs-period';

/**
 * Um atalho da barra de período: o rótulo, o período que ele produz e a
 * resposta de "é este que está na tela?". O componente pergunta, não decide.
 */
export class PeriodShortcut {
  constructor(
    readonly label: string,
    private readonly build: () => CostsPeriod,
  ) {}

  period(): CostsPeriod {
    return this.build();
  }

  isApplied(applied: CostsPeriod): boolean {
    return applied.equals(this.build());
  }
}
